import { render, staticRenderFns } from "./DirectorRecords.vue?vue&type=template&id=0dd097a9&"
import script from "./DirectorRecords.vue?vue&type=script&lang=js&"
export * from "./DirectorRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports